// @flow

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { MobileCta } from 'data/global/nav';
import { useNavState, usePageState } from 'contexts';
import { Color, flex, Layout, maxWidthContainer, Transition } from 'styles';
import { PageType } from 'Constants';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: ${Color.BLURPLE_LIGHT};
  z-index: ${Layout.Z_INDEX_MOBILE_CTA_BAR};
  ${flex()};
  transition: ${({ visible }) => (visible ? `transform ${Transition.DEFAULT_MOBILE}` : 'none')};
  ${({ visible, scrollingUp }) =>
    visible
      ? scrollingUp
        ? `transform: translateY(${Layout.NAV_HEIGHT_MOBILE}px)`
        : `transform: translateY(0)`
      : `transform: translateY(-100%)`};

  > div {
    ${maxWidthContainer()};
    ${flex('space-between', 'center')};
    padding: 18px 0;

    p {
      font-weight: 500;
      font-size: 1.2rem;
      line-height: 1.5;
      margin-right: 12px;
      margin-bottom: 0;
    }

    div {
      flex: 0 0 auto;
    }
  }
`;

const MobileCtaBar = () => {
  const {
    page: { product },
    headerConfig: {
      toggleHidden: { mobileCta },
    },
  } = usePageState();
  const { renderMobile, atTop, scrollingUp } = useNavState();
  return useMemo(() => {
    const content =
      product.includes(PageType.PRODUCT.NONE) || product.length > 1 ? MobileCta[PageType.PRODUCT.NONE] : MobileCta[product[0]];
    return !mobileCta && renderMobile ? (
      <Wrapper visible={!atTop} scrollingUp={scrollingUp} aria-hidden={true}>
        <div>
          <p>{content}</p>
        </div>
      </Wrapper>
    ) : null;
  }, [renderMobile, mobileCta, atTop, scrollingUp, product]);
};

export default MobileCtaBar;
